<template>
	<div class="tpl my-wallet-wrap">
		<mt-header title="我的钱包" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			 <mt-button @click.native="showWalletDetail" slot="right">钱包明细</mt-button>
		</mt-header>
		<div class="totle-num">
			<img src="../../assets/img/mine/center_mark_img_money.png" alt="" />
			<p class="name">现金总额(元)</p>
			<p class="value">{{walletInfo.amount}}</p>
		</div>
		<div class="num-type">
			<ul>
				<li>
					<p class="name">我的桃花币</p>
					<p class="value">{{walletInfo.amount}}</p>
				</li>
				<li>
					<p class="name">金额可提现</p>
					<p class="value">{{walletInfo.forward_amount}}</p>
				</li>
			</ul>
		</div>
		<div class="options">
			<button @click="showTip">充值</button>
			<button @click="showTip">提现</button>
		</div>
	</div>
</template>

<script>
	export default{
		name:"my-wallet",
		data(){
			return{
				uid:"",
				walletInfo:""
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getWalletInfo();
		},
		methods:{
			getWalletInfo(){
				this.$axios({
					url:"My/MyWallet",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.walletInfo = res.data.data
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			showTip(){
				this.$toast({message:"下载鱼水缘APP后操作",position: "bottom",duration: 2000});
			},
			showWalletDetail(){
				this.$router.push({name:"my-wallet-detail"})
			}
		}
	}
</script>

<style scoped>
	.my-wallet-wrap{
		padding-top: 2.5rem;
	}
	>>>.mint-button-text{
		color: #5415F9;
	}
	.my-wallet-wrap .totle-num{
		text-align: center;
		background: #FFFFFF;
		padding: 1rem 0 0.8rem;
	}
	.my-wallet-wrap .totle-num img{
		width: 5.4rem;
	}
	.my-wallet-wrap .totle-num .name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 2rem;
	}
	.my-wallet-wrap .totle-num .value{
		font-size: 1.5rem;
		color: #5415F9;
		font-weight: bold;
		line-height: 2rem;
		letter-spacing: 2px;
	}
	.my-wallet-wrap .num-type ul{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 3px 0;
	}
	.my-wallet-wrap .num-type li{
		text-align: center;
		flex: 1;
		padding: 0.5rem 0 0.3rem;
		font-size: 0.9rem;
		line-height: 1.6rem;
		background: #fff;
	}
	.my-wallet-wrap .num-type li:first-of-type{
		border-right: 1px solid #f3f3f3;
	}
	.my-wallet-wrap .num-type li .name{
		color: #282828;
	}
	.my-wallet-wrap .num-type li .value{
		color: #5415F9;
	}
	.my-wallet-wrap .options{
		padding: 0.5rem 2rem;
	}
	.my-wallet-wrap .options button{
		width: 100%;
		height: 2.5rem;
		margin: 1rem 0 1.5rem;
		border-radius: 4px;
		outline: 0;
		font-size: 1rem;
		display: block;
	}
	.my-wallet-wrap .options button:first-of-type{
		border: 1px solid #5415F9;
		color: #5415F9;
		background: none;
	}
	.my-wallet-wrap .options button:last-of-type{
		border: 0;
		color: #fff;
		background:linear-gradient(45deg,rgba(118,68,250,1) 0%,rgba(156,124,255,1) 100%);
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyWallet.vue